import { makeStyles } from 'tss-react/mui';

const name = 'HomePage';

export const useHomePageStyles = makeStyles({ name })(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
    },
  },
  suspendedUserAlert: {
    [theme.breakpoints.down('sm')]: {
      width: `calc(100% - ${theme.spacing(9)})`,
    },

    [theme.breakpoints.down('xs')]: {
      width: `calc(100% - ${theme.spacing(4)})`,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(8),

    [theme.breakpoints.down('xl')]: {
      gap: theme.spacing(7),
    },

    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(6),
    },
  },
}));
